import { SET_FEATURED_EVENT } from '../../actions/persist/featuredEvent';

const initialState = {
  eventId: null,
  nextRotationAt: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_FEATURED_EVENT:
      return {
        ...state,
        eventId: action.payload.eventId,
        nextRotationAt: action.payload.nextRotationAt,
      };
    default:
      return state;
  }
};
